import { Dispatch, SetStateAction, useCallback, useState } from 'react';

export const useBoolean = (
  initialValue?: boolean,
): [boolean, () => void, Dispatch<SetStateAction<boolean>>] => {
  const [value, setValue] = useState(initialValue || false);

  const toggleValue = useCallback(() => {
    setValue((currentValue) => !currentValue);
  }, []);

  return [value, toggleValue, setValue];
};
